import { createFileRoute } from "@tanstack/react-router";
import { PacketPage } from "@/components/app/portal/packet-page";

export const Route = createFileRoute("/family-portal/$residentId/packets/$packetId")({
  head: () => ({ meta: [{ title: "Paperwork | People AI" }] }),
  component: FamilyPacketPage,
});

/** Admission paperwork a family member signs for one resident. */
function FamilyPacketPage() {
  const { residentId, packetId } = Route.useParams();
  return <PacketPage kind="family" residentId={residentId} packetId={packetId} />;
}
